import { render, staticRenderFns } from "./DefinitionList.vue?vue&type=template&id=f6cab682&"
import script from "./DefinitionList.vue?vue&type=script&lang=ts&"
export * from "./DefinitionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports